export default "__VITE_ASSET__5d3f64b2__"